import type { VoidFunctionComponent } from 'react';

import Icon, { icons } from '../Icon';

import styles from './FileTree.module.less';

export type FileTreeNodeIconProps = {
  /**
   * Whether the node is a directory or a file.
   */
  isDirectory: boolean;
};

/**
 * A component that displays an icon indicating if a node is a directory or a file.
 *
 * @param {FileTreeNodeIconProps} props - The props for the component.
 * @param {boolean} props.isDirectory - Whether the node is a directory or a file.
 */
const FileTreeNodeIcon: VoidFunctionComponent<FileTreeNodeIconProps> = ({ isDirectory }) => (
  <span className={styles.treeViewNodeIcon}>
    <Icon icon={isDirectory ? icons.folderO : icons.fileO} />
  </span>
);

export default FileTreeNodeIcon;
